module.exports = {
	"next": "далее",
	"skip": "Перейти к созданию Cozy ",
	"cancel": "отмена",
	"back": "назад",
	"sign up": "регистрация",
	"add email": "добавить почтовый аккаунт",
	"welcome": "впусти меня!",
	"confirm": "подтвердить",
	"user missing properties": "Извините, но данный пользователь не существует.",
	"step welcome user": "Привет %{name}!",
	"step welcome anon": "Привет!",
	"step welcome logout": "Вы не %{name}?",
	"step welcome congrats": "Поздравляем, благодаря вам ваши персональные данные в надежном месте, в вашем Cozy.",
	"step welcome next": "Далее",
	"step agreement title": "Правила Использования",
	"step agreement subtitle": "Для того чтобы открыть свой Cozy, вы должны прочитать и согласиться с нашими условиями предоставления услуг. Как обычные люди, мы догадываемся, что Вы не будете читать. Этот краткий вариант мы сделали специально для вас:",
	"step agreement element 0": "Верните себе контроль и надежность хранения ваших данных, прямо в вашем доме!",
	"step agreement element 1": "Мы заботимся о вас и вашем удобстве...",
	"step agreement element 2": "...если вы сделали что-то неверное с Cozy или вашими данными",
	"step agreement element 3": "Выберите, какие сервисы используют ваши данные и поймите их цели",
	"step agreement element 4": "Никто (даже мы) не можем получить доступ к вашим данным в Cozy.",
	"step agreement element 5": "У нас есть немного информации о Вас,  собранной в соответствии с законом и для улучшения качества обслуживания",
	"step agreement stats": "Я разрешаю Cozy собирать обезличенные данные.",
	"step agreement description 1": "Вы можете получить доступ к полной версии правил по обслуживанию.",
	"step agreement description 2": "Нажимая на кнопку \"Принять\",  вы подтверждаете, что вы прочитали, поняли и согласны с правилами пользования.",
	"step agreement description link": "Здесь.",
	"step agreement next": "Принят",
	"step preset": "настройки",
	"step import": "загрузка ваших данных",
	"step email settings": "настройка вашего email",
	"preset email": "e-mail",
	"preset email tip": "Он будет использован для связи с вами в случае утери вашего пароля.",
	"preset name": "имя",
	"step password empty": "Поле пароля не может быть пустым.",
	"step password too weak": "Введенный пароль ненадежен. Вы должны добавить разность регистров, числа, спецсимволы или удлинить его.",
	"step password title": "Безопасность вашего пароля",
	"step password label": "пароль",
	"step password input placeholder": "например \"dEj875ghj9273;eR\"",
	"step password submit": "подтвердить",
	"step password show": "Показать пароль",
	"step password hide": "Скрыть пароль",
	"step password description": "Ваш пароль должен быть максимально возможно сложным. Это предотвратить несанкционированный доступ к вашему облаку.  Обязательно использование разных регистров, спецсимволов и цифр.",
	"step password server error": "Что-то пошло не так. Ваш пароль не был сохранен.",
	"step infos title": "Заполните ваш Cozy",
	"step infos description": "Некоторые сведения, которые необходимы для создания вашего Cozy.",
	"step infos public_name label": "Имя пользователя",
	"step infos public_name placeholder": "The public display name your Cozy will use to speak with you.",
	"step infos email label": "Электронная почта",
	"step infos email placeholder": "Используйте ваш Cozy для сброса вашего пароля.",
	"step infos timezone label": "Часовой пояс",
	"step infos timezone placeholder": "Выбор часового пояса поможет верно отображать события в календаре.",
	"step infos submit": "Подтвердить",
	"step infos fetch data error": "Не удалось получить данные с сервера.",
	"missing public_name": "Вам необходимо заполнить имя пользователя.",
	"missing email": "Вам необходимо заполнить электронную почту.",
	"invalid email format": "Вы ввели некорректный адрес электронной почты.",
	"missing timezone": "Вы должны выбрать часовой пояс",
	"invalid timezone": "Часовой пояс указан неверно.",
	"step accounts title": "Ваш Cozy успешно создан.",
	"step accounts description line 1": "Теперь мы проведем вас по шагам подключения Cozy к вашим сервисам.",
	"step accounts description line 2": "Важнейшая цель Cozy, это помочь вам безопасность ваших данных.",
	"step accounts next": "Обзор",
	"myaccounts info": "Теперь вы можете получить доступ к Вашим уютным в любое время, нажав кнопку \"Продолжить\"",
	"myaccounts next": "Продолжить",
	"step confirmation title": "Приветствуем в вашем личном хранилище!",
	"step confirmation description line 1": "Ваш Cozy теперь готов.",
	"step confirmation description line 2": "Вы можете получить обратно свои данные из многих сервисов, а также устанавливать приложения, из  нашего магазина.",
	"step confirmation next": "Вход",
	"step server error": "An error occurred while saving your progression. Reloading the page should fix the problem.",
	"preset name tip": "Она отображается, когда вы делитесь файлами с людьми или приглашаете их на мероприятия.",
	"preset password": "пароль",
	"preset password tip": "Необходим сложный пароль из более чем 8 символов( рекомендуются спец. символы).",
	"preset timezone": "Часовой пояс",
	"preset timezone tip": "Ваш часовой пояс необходим для корректного отображения дат событий в календаре.",
	"preset opt-in help": "Разрешить Cozy собирать мою статистику использования для улучшения продукта.",
	"preset opt-out newsletter": "Подписаться на рассылку Beta Cozy (крайне рекомендуется).",
	"import from google": "Загрузить данные из моего Google аккаунта.",
	"import google account": "Синхронизировать мой Gmail аккаунт и загрузить календарь, контакты и фотографии из Google.",
	"import google account tip": "Необходимо войти в аккаунт Google, чтобы Cozy имел доступ к данным, размещенным в сервисах Google",
	"leave google title": "Загрузка ваших данных в Cozy",
	"leave google help me": "Я не понимаю, что я хочу сделать, пожалуйста помогите мне!",
	"leave google sign in content": "Войдите в вашу учетную запись Google и предоставьте Cozy доступ к нему. Вы получите строку символов. Скопируйте ее в буфер обмена.",
	"leave google sign in": "Войти в учетную запись Google",
	"leave google code content": "Затем, скопируйте и вставьте код из всплывающей области:",
	"leave google code": "код google",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Выберите, что сделать с данными размешенными в сервисах Google:",
	"leave google choice sync gmail": "GMail - Доступ к вашей почте из Cozy",
	"leave google choice contacts": "Разовая загрузка из Контактов Google",
	"leave google choice calendar": "Разовая загрузка из Календаря Google",
	"leave google choice photos": "Разовая загрузка из Фото Google",
	"leave google confirm": "Загрузка данных",
	"import error": "Возникает ошибка при попытке загрузить ваши данные. Пожалуйста, повторите попытку позже из специального приложения.",
	"login welcome user": "Привет %{username}",
	"login welcome anon": "Привет",
	"login enter your password": "Введите ваш пароль для доступа к вашему Cozy.",
	"login password": "пароль",
	"login otp": "Код аутентификации",
	"login submit": "Log in",
	"login auth success": "Успешная авторизация, заходим!",
	"login recover": "Forgotten password? Send me an email to change it.",
	"login recover busy": "Sending an email containing instructions",
	"login recover sent title": "Письмо отправлено",
	"login recover sent message": "Пожалуйста проверьте вашу почту, следуйте инструкциям в письме для сброса вашего пароля",
	"login recover error title": "Ошибка отправки письма",
	"login recover error message": "Ошибка отправки сообщения восстановления пароля, пожалуйста, проверьте работу вашего MTA или свяжитесь с администратором сервера",
	"login wrong password title": "Неправильные учетные данные",
	"login wrong password message": "The credentials you entered are incorrect. Please try again.",
	"login server error": "An error occured, please try again.",
	"reset password request success title": "Email sent",
	"reset password request success message": "Check your emails, and follow the instructions to change your password.",
	"reset password request error": "An error occurred, the email has not been sent. Please try again. If the error persists, contact us at contact@cozycloud.cc.",
	"reset welcome user": "Change your password",
	"reset enter your password": "%{username}, set a new password to recover access to your Cozy.",
	"reset password": "пароль",
	"reset submit": "сброс вашего пароля",
	"reset auth success": "пароль успешно сброшен",
	"reset wrong password title": "Ваш пароль не может быть сброшен",
	"reset wrong password message": "Введенный пароль некорректен или ваш код сброса устарел",
	"reset password error invalid key": "Your password request has expired. Please request a new one.",
	"reset password error password too weak": "Your password is too weak. You should add an uppercase, a number, a special character or a longer password.",
	"setup title": "Мы настраиваем ваш Cozy…",
	"setup message": "Вы близки к тому, чтобы иметь личное облако, где хранятся ваши данные.",
	"setup on mobile title": "Синхронизируйте ваши данные с вашим Android устройством!",
	"setup on mobile message": "Посмотрите наше приложение в Google Play:",
	"welcome title": "Поздравляю, что вернули контроль над своими личными данными!",
	"welcome message": "Теперь вы можете хранить свои данные на вашем личном облаке. В отличие от большинства облачных сервисов, оно не собирает данные о том, что вы в нем храните."
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/ru.json
// module id = 47
// module chunks = 0